import React from "react";
import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button: React.FC<ButtonProps> = ({ color, children, onClick }) => (
  <StyledButton color={color} onClick={onClick}>
    {children}
  </StyledButton>
);

export default Button;
